import {
  Box,
  // Button,
  Heading,
  Image,
  Flex,
  Text,
  Stack,
} from '@chakra-ui/react';
import { HoveringBox } from '~/components/ui/motion/Box';
import { useAgency } from '~/hooks/useAgency';

const Maintenance = () => {
  const { getIllustrationsRoute } = useAgency();

  return (
    <Flex
      direction="column"
      inset="0"
      justifyContent="center"
      alignItems="center"
    >
      <HoveringBox>
        <Image
          w="xs"
          mx="auto"
          mb="6"
          src={getIllustrationsRoute('maintenance.svg')}
          alt="Erik Olsson"
        />
      </HoveringBox>

      <Box px="2">
        <Stack textAlign="center" spacing="6" maxW="600" mx="auto">
          <Heading textAlign="center" size={{ mobile: 'md', tablet: 'lg' }}>
            Renoveringsarbete pågår
          </Heading>
          <Text fontSize={{ mobile: 'md', tablet: 'lg' }}>
            Habitys community för digitala mäklartjänster uppgraderas för att ge
            dig ännu bättre verktyg och resurser. Vi är snart tillbaka med en ny
            och förbättrad plattform. Tack för tålamodet!
          </Text>
        </Stack>
      </Box>
    </Flex>
  );
};

export default Maintenance;
